module.exports = __webpack_public_path__ + "img/google_workspace.3bf6bc8f.png";